//import useFaviconFromLogo from "@/functions/UseFaviconFromLogo";
import Picture from "./Picture";
import { useAtomValue } from "jotai";
import { logoUrlAtom } from "@/stores/logoAtom";

interface LogoProps {
    whiteLogo?: boolean;
}

export default function Logo({ whiteLogo = false }: LogoProps) {
    //const { faviconUrl } = useFaviconFromLogo();
    const logoSize = "w-[128px] h-[128px]";
    // const src = faviconUrl ?? "/supervisor/logo.png";
    const src = useAtomValue(logoUrlAtom);

    return <Picture src={src} alt="logo" customSize={logoSize} isFullBrightness={whiteLogo} />;
}
